import { Injectable } from '@angular/core';
import {  HttpRequest, HttpEventType, HttpResponse, HttpHeaders, HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { HttpUtilService } from '@services/http-util.service';
import { environment } from '@env/environment';


@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient, private httpUtil: HttpUtilService) { }

  /**
   * Upload a file
   * @param file file to upload
   * @param route folder route to upload
   */
  public uploadSingle(file, route = '',parent?): Observable<any> {
    console.log(route);
    // this will be the our resulting map
    let status: any = {};
    // create a new progress-subject for every file
    const upload = new Subject<any>();
    const url = route + '/' + file.name;
    status = {
      progress: 0,
      file: file.name,
      size: file.size,
      url: url,
      fileref: file,
      existing: false
    };
    this.httpUtil.request('POST', environment.apiRoot + '/upload/' + url + '?file_type=' + file.type,
      {parent} , null, true).subscribe(f => {
        if (f.error) {
          console.log(f);
          status.error = f.error;
          upload.next(status);
          upload.complete();
        } else {
          status.existing = f.existing;
          // create a new multipart-form for every file
          const formData: FormData = new FormData();
          formData.append('file', file, file.name);

          // create a http-post request and pass the form
          // tell it to report the upload progress
          let reqHeaders = new HttpHeaders();
          reqHeaders = reqHeaders.set('Content-type', file.type);
          const req = new HttpRequest('PUT', f.url, file, {
            headers: reqHeaders, reportProgress: true

          });

          // send the http-request and subscribe for progress-updates
          this.http.request(req).subscribe(event => {

            if (event.type === HttpEventType.UploadProgress) {

              // calculate the progress percentage
              const percentDone = Math.round(100 * event.loaded / event.total);

              // pass the percentage into the progress-stream
              status.progress = percentDone;
              upload.next(status);
            } else if (event instanceof HttpResponse) {

              // Close the progress-stream if we get an answer form the API
              // The upload is complete
              upload.complete();
            }
          });
        }
        // }
        // Save every progress-observable in a map of all observables
      });


    // return the map of progress.observables
    return upload;

  }
}
